import _ from 'lodash';
import moment from 'moment';
import { toastSaveSuccess } from 'Common/utilities/alert';
import { FIRE_GENERAL_ID } from 'Common/constants/customerCareModules';
import { setCompletionUtil } from '../util/tabTableCommon';
import { parseToInt10 } from 'Common/utilities/parse';

export default class AnnualReviewsCtrl {
  constructor(
    NgTableParams,
    customerCareService,
    customerCareInsuranceService,
    customerCareTabsService,
    uiService,
  ) {
    'ngInject';

    this.NgTableParams = NgTableParams;
    this.toastSaveSuccess = toastSaveSuccess;
    this.customerCareInsuranceService = customerCareInsuranceService;
    this.customerCareTabsService = customerCareTabsService;
    this.customerCareService = customerCareService;
    this.uiService = uiService;
    this.FIRE_GENERAL_ID = FIRE_GENERAL_ID;
  }

  $onInit() {
    this.isBulkEmailActive = this.customerCareTabsService.isBulkEmailActive();
    this.isLoading = false;
    this.isFromCompleted = false;
    this.totalRecords = 0;
    this.currentPage = 1;
    this.tableData = [];

    this.defaultTableSettings = {
      page: 1,
      count: 10,
      sorting: {
        ReviewDate: 'asc',
      },
    };

    if (this.uiService.newCustomerCareEvents) {
      this.loadAnnualReviews();
    } else {
      this.loadTableData();
    }
  }

  $onChanges(changes) {
    if (changes.filterUpdateCount) {
      this.currentPage = 1;
      if (this.defaultTableSettings) {
        this.defaultTableSettings.page = 1;
      }
      this.isFromCompleted = false;
      if (this.tableParams) {
        this.tableParams.reload();
      }
    }

    if (changes.refreshCount && this.tableParams) {
      this.tableParams.reload();
    }
  }

  onActionSelected($event) {
    this.onSendModal({ $event });
  }

  markCompleted(item) {
    item.isComplete = !item.isComplete;
    this.setCompletion(item);
  }

  setCompletion(item) {
    if (this.uiService.newCustomerCareEvents) {
      const payload = {
        AnnualEventMonth: item.reviewMonth,
        AnnualEventYear: parseToInt10(item.reviewYear),
        IsCompleted: item.isComplete,
        FamilyId: item.familyID,
      };
      this.customerCareService
        .setAnnualReviewCompletion(payload)
        .then(() => this.tableParams.reload());
    } else {
      setCompletionUtil(this)(item);
    }
  }

  onItemCheckboxToggled(item) {
    if (this.isBulkEmailActive) {
      this.onTableDataLoaded({ $event: { tableData: this.tableData } });
    } else {
      item.isComplete = item.isChecked;
      this.setCompletion(item);
    }
  }

  gotoContact(familyId) {
    this.viewContact({ $event: { familyId } });
  }

  onPageChange(event) {
    this.defaultTableSettings.page = event.$e.pageNumber;
    this.currentPage = event.$e.pageNumber;
    this.isFromCompleted = false;
    this.tableParams.reload();
  }

  loadTableData() {
    const ctrl = this;
    this.tableParams = new this.NgTableParams(ctrl.defaultTableSettings, {
      counts: [],
      total: 0,
      getData(params) {
        const sortBy = params.orderBy()[0].slice(1);
        const sortOrder = _.values(params.sorting())[0].toUpperCase();
        if (!ctrl.isFromCompleted) {
          ctrl.isLoading = true;
        }

        const newFilter = {
          ...ctrl.filterData,
          sortBy,
          sortOrder,
          pageNumber: ctrl.currentPage,
        };
        return ctrl.customerCareInsuranceService
          .getAnnualReviews(newFilter)
          .then((response) => {
            ctrl.isLoading = false;
            ctrl.tableData = response;
            ctrl.tableData.map((item) => {
              item.isComplete = newFilter.isCompleted;
              return item;
            });
            ctrl.totalRecords =
              ctrl.tableData.length && ctrl.tableData[0].totalCount;
            ctrl.onTableDataLoaded({ $event: { tableData: ctrl.tableData } });

            if (ctrl.totalRecords) {
              params.total(ctrl.totalRecords);
            } else {
              params.total(0);
            }
            return ctrl.tableData;
          });
      },
    });
  }

  // Load table data for newCustomerCareEvents feature flag
  loadAnnualReviews() {
    const ctrl = this;
    this.tableParams = new this.NgTableParams(ctrl.defaultTableSettings, {
      counts: [],
      total: 0,
      getData(params) {
        const sortBy = params.orderBy()[0].slice(1);
        const sortOrder = _.values(params.sorting())[0].toUpperCase();
        if (!ctrl.isFromCompleted) {
          ctrl.isLoading = true;
        }

        const newFilter = {
          searchedAdvisorID: ctrl.filterData.brokerId,
          fromDate: ctrl.filterData.reviewDateStart,
          toDate: ctrl.filterData.reviewDateEnd,
          pageNumber: ctrl.filterData.currentPage,
          pageSize: ctrl.filterData.pageSize,
          sortColumn: sortBy,
          sortType: sortOrder,
          isCompleted: ctrl.filterData.isCompleted,
          isIncludeSubscribersToMktg: false,
        };

        return ctrl.customerCareInsuranceService
          .getAnnualReviewsNewCustomerCareEvents(newFilter)
          .then((response) => {
            ctrl.isLoading = false;

            ctrl.tableData = response.data.ClientsAnnualReviewList.map((e) => ({
              familyID: e.FamilyID,
              customer: e.FamilyFullName,
              reviewMonth: e.ReviewMonth,
              reviewMonthFormatted: moment(e.ReviewMonth, 'M').format('MMM'),
              isCurrentMonth:
                moment(e.ReviewMonth, 'M').format('MMM') ===
                moment().format('MMM'),
              reviewYear: e.ReviewYear,
              brokerID: newFilter.brokerId,
              email: e.Email,
              mobile: e.Mobile,
              country: e.Country,
              totalCount: response.data.TotalCount,
              communicationSent: e.CommunicationSent,
              isComplete: newFilter.isCompleted,
            }));

            ctrl.totalRecords =
              ctrl.tableData.length && ctrl.tableData[0].totalCount;
            ctrl.onTableDataLoaded({ $event: { tableData: ctrl.tableData } });

            if (ctrl.totalRecords) {
              params.total(ctrl.totalRecords);
            } else {
              params.total(0);
            }
            return ctrl.tableData;
          });
      },
    });
  }
}
